export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAIL = 'SIGN_UP_FAIL';
export const SIGN_UP_START = 'SIGN_UP_START';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_FAIL = 'SIGN_IN_FAIL';
export const SIGN_IN_START = 'SIGN_IN_START';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';


export const CUSTOMER_LIST_SUCCESS = 'CUSTOMER_LIST_SUCCESS';
export const CUSTOMER_LIST_FAIL = 'CUSTOMER_LIST_FAIL';
export const CUSTOMER_COUNT_SUCCESS = 'CUSTOMER_COUNT_SUCCESS';
export const CUSTOMER_COUNT_FAIL = 'CUSTOMER_COUNT_FAIL';
export const NEW_CUSTOMER_SUCCESS = 'NEW_CUSTOMER_SUCCESS';
export const NEW_CUSTOMER_FAIL = 'NEW_CUSTOMER_FAIL';
export const CUSTOMER_UPDATE_SUCCESS = 'CUSTOMER_UPDATE_SUCCESS';
export const CUSTOMER_UPDATE_FAIL = 'CUSTOMER_UPDATE_FAIL';
export const CUSTOMER_EDIT_SUCCESS = 'CUSTOMER_EDIT_SUCCESS';
export const CUSTOMER_FIND_FAIL = 'CUSTOMER_FIND_FAIL';
export const CUSTOMER_FIND_SUCCESS = 'CUSTOMER_FIND_SUCCESS';
export const CUSTOMER_INFO_FAIL = 'CUSTOMER_INFO_FAIL';
export const CUSTOMER_INFO_SUCCESS = 'CUSTOMER_INFO_SUCCESS';
export const CUSTOMER_YEARLY_FAIL = 'CUSTOMER_YEARLY_FAIL';
export const CUSTOMER_YEARLY_SUCCESS = 'CUSTOMER_YEARLY_SUCCESS';
export const CUSTOMER_DELETE_SUCCESS = 'CUSTOMER_DELETE_SUCCESS';
export const CUSTOMER_DELETE_FAIL = 'CUSTOMER_DELETE_FAIL';
export const CUSTOMER_EMAIL_SUCCESS = 'CUSTOMER_EMAIL_SUCCESS';
export const CUSTOMER_EDIT_CLEAR = 'CUSTOMER_EDIT_CLEAR';


export const COUPON_LIST_SUCCESS = 'COUPON_LIST_SUCCESS';
export const COUPON_LIST_FAIL = 'COUPON_LIST_FAIL';
export const COUPON_COUNT_SUCCESS = 'COUPON_COUNT_SUCCESS';
export const COUPON_COUNT_FAIL = 'COUPON_COUNT_FAIL';
export const NEW_COUPON_SUCCESS = 'NEW_COUPON_SUCCESS';
export const NEW_COUPON_FAIL = 'NEW_COUPON_FAIL';
export const COUPON_UPDATE_SUCCESS = 'COUPON_UPDATE_SUCCESS';
export const COUPON_UPDATE_FAIL = 'COUPON_UPDATE_FAIL';
export const COUPON_EDIT_SUCCESS = 'COUPON_EDIT_SUCCESS';
export const COUPON_FIND_FAIL = 'COUPON_FIND_FAIL';
export const COUPON_FIND_SUCCESS = 'COUPON_FIND_SUCCESS';
export const COUPON_DELETE_SUCCESS = 'COUPON_DELETE_SUCCESS';
export const COUPON_DELETE_FAIL = 'COUPON_DELETE_FAIL';
export const REDIRECT_SUCCESS = 'REDIRECT_SUCCESS';


export const NEW_VEHICLE_SUCCESS = 'NEW_VEHICLE_SUCCESS';
export const NEW_VEHICLE_FAIL = 'NEW_VEHICLE_FAIL';


export const EMPLOYEE_LIST_SUCCESS = 'EMPLOYEE_LIST_SUCCESS';
export const EMPLOYEE_LIST_FAIL = 'EMPLOYEE_LIST_FAIL';
export const EMPLOYEE_UPDATE_SUCCESS = 'EMPLOYEE_UPDATE_SUCCESS';
export const EMPLOYEE_UPDATE_FAIL = 'EMPLOYEE_UPDATE_FAIL';
export const EMPLOYEE_COUNT_SUCCESS = 'EMPLOYEE_COUNT_SUCCESS';
export const EMPLOYEE_COUNT_FAIL = 'EMPLOYEE_COUNT_FAIL';
export const EMPLOYEE_EDIT_SUCCESS = 'EMPLOYEE_EDIT_SUCCESS';

export const ORDER_LIST_SUCCESS = 'ORDER_LIST_SUCCESS';
export const ORDER_LIST_FAIL = 'ORDER_LIST_FAIL';
export const ORDER_COUNT_SUCCESS = 'ORDER_COUNT_SUCCESS';
export const ORDER_COUNT_FAIL = 'ORDER_COUNT_FAIL';
export const ORDER_FIND_SUCCESS = 'ORDER_FIND_SUCCESS';
export const ORDER_FIND_FAIL = 'ORDER_FIND_FAIL';
export const ORDER_UPDATE_SUCCESS = 'ORDER_UPDATE_SUCCESS';
export const ORDER_UPDATE_FAIL = 'ORDER_UPDATE_FAIL';
export const NEW_ORDER_SUCCESS = 'NEW_ORDER_SUCCESS';
export const NEW_ORDER_FAIL = 'NEW_ORDER_FAIL';
export const ORDER_REVENUE_SUCCESS = 'ORDER_REVENUE_SUCCESS';
export const ORDER_REVENUE_FAIL = 'ORDER_REVENUE_FAIL';
export const ORDER_FEATURED_SUCCESS = 'ORDER_FEATURED_SUCCESS';
export const ORDER_FEATURED_FAIL = 'ORDER_FEATURED_FAIL';


export const SET_LOADING_AUTH = 'SET_LOADING_AUTH';
export const NOT_LOADING_AUTH = 'NOT_LOADING_AUTH';
export const SET_LOADING_VEHICLE = 'SET_LOADING_VEHICLE';
export const NOT_LOADING_VEHICLE = 'NOT_LOADING_VEHICLE';
export const SET_LOADING_CUSTOMER = 'SET_LOADING_CUSTOMER';
export const NOT_LOADING_CUSTOMER = 'NOT_LOADING_CUSTOMER';
export const SET_LOADING_EMPLOYEE = 'SET_LOADING_EMPLOYEE';
export const NOT_LOADING_EMPLOYEE = 'NOT_LOADING_EMPLOYEE';
export const SET_LOADING_ORDER = 'SET_LOADING_ORDER';
export const NOT_LOADING_ORDER = 'NOT_LOADING_ORDER';
export const SET_LOADING_COUPON = 'SET_LOADING_ORDER';
export const NOT_LOADING_COUPON = 'NOT_LOADING_ORDER';

export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';
